export default __webpack_public_path__ + "static/media/file-pdf-regular.3314a02b.svg";